export const STATE_KEY: string = 'accounts'
